import { render, staticRenderFns } from "./BtnNotaCredito.vue?vue&type=template&id=fd374114&"
import script from "./BtnNotaCredito.vue?vue&type=script&lang=js&"
export * from "./BtnNotaCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports